module.exports = __webpack_public_path__ + "img/budget-2.9570ac64.png";